import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { Col, Row, Card, Dropdown } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumbs from "../../../shared/components/Breadcrumbs";
import { loadChatMetricsDataRequest, loadUserMetricsDataRequest } from "../redux/Actions";
import { ResponsiveContainer, ComposedChart, Bar, Pie, PieChart,BarChart, AreaChart, Area, LineChart, Line, CartesianGrid, Legend, XAxis, YAxis, Tooltip, Cell } from 'recharts';

const MetricsUser = () => {
  const [dateRange, setDateRange] = useState(30);
  let dispatch = useDispatch();
  let navigate = useNavigate();
  let location = useLocation();
  let {user} = useSelector((state) => state.chatgroup);
  console.log("Data",user);

  const getDateRangeText = () => {
    switch (dateRange) {
      case 7:
        return "Last 7 Days";
      case 30:
        return "Last 30 Days";
      case 90:
        return "Last 90 Days";
      default:
        return "Select Date Range";
    }
  };

  
  useEffect(() => {
    dispatch(loadUserMetricsDataRequest({ dateRange }));
  }, [dateRange, dispatch]);

  const handleDateRangeChange = (range) => {
    setDateRange(range); 
  };  

  let columns = [
    {
      display_name: "id",
      field: "id",
      type: "number",
      hide: true,
      headerClass: "custom-header", 
      flex: 1,
    },
    {
      display_name: "Employee Name",
      field: "userName",
      type: "text",
      headerClass: "custom-header", 
      flex: 1,
    },
    {
      display_name: "Message Count",
      field: "messageCount",
      type: "number",
      headerClass: "custom-header", 
      flex: 1,
    },
  ];

  const transformedData = user?.dateWiseActiveUsers?.map((item) => {
    const transformedItem = { date: item.date };
    let totalActiveUsers = 0;
      let totalMessages = 0;
  
    item.jobLevels.forEach((jobLevel) => {
      transformedItem[`${jobLevel.jobLevel}_activeUsers`] = jobLevel.activeUsers; // Add job-level active users
      transformedItem[`${jobLevel.jobLevel}_totalMessages`] = jobLevel.totalMessages; // Add job-level total messages
      totalActiveUsers += jobLevel.activeUsers; // Sum up active users
      totalMessages += jobLevel.totalMessages;
    });
  
    transformedItem.totalActiveUsers = totalActiveUsers; // Add total active users for the day
    transformedItem.totalMessages = totalMessages;
    return transformedItem;
  }) || [];
  const getColor = (index) => {
    const colors = ["#8884d8", "#82ca9d", "#ffc658", "#ff8042", "#a4de6c", "#d0ed57"];
    return colors[index % colors.length];
  };
  const keyMapping = {
    store: "RSR & RAM",
    store_covering: "RSM",
    district: "DSOM",
    region: "AVP",
    corporate: "Corporate",
    area: "Area",
  };

  
  return (
    <>
      <div>
        <Row>
          <Card>
            <Card.Body>
            <div className="text-end mb-3">
                <Dropdown>
                  <Dropdown.Toggle className="default-btn-color pt-1 pb-1 btn btn-primary" id="dropdown-basic">
                    {getDateRangeText()} {/* Show selected range */}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => handleDateRangeChange(7)}>Last 7 Days</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleDateRangeChange(30)}>Last 30 Days</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleDateRangeChange(90)}>Last 90 Days</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            <Row className="gy-1 dashboard">
                {/* <Col xs={12} md={6} lg={3}>
                  <StatTile
                    text="Total Messages"
                    number={user.totalMessages}
                    color="#09b8e4"
                    icon="fas fa-envelope"
                  />
                </Col> */}

                <Col xs={12} md={6} lg={3}>
                  <StatTile
                    text="Active Users"
                    number={user.activeUsers}
                    color="#4CAF50"
                    icon="fas fa-users"
                  />
                </Col>

                <Col xs={12} md={6} lg={3}>
                  <StatTile
                    text="Inactive Users"
                    number={user.inactiveUsers}
                    color="#FF5722"
                    icon="fas fa-user-slash"
                  />
                </Col>

                <Col xs={12} md={6} lg={3}>
                  <StatTile
                    text="Avg Messages/User"
                    number={user.averageMessagesPerUser}
                    color="#FFC107"
                    icon="fas fa-chart-line"
                  />
                </Col>
              </Row>

              <Row className={"gy-3 my-1 dashboard"}>
              <Col xs={12} lg={6} className="align-self-stretch">
                  <Card style={{ height: "100%", border: 0, borderLeft: `3px solid #5C5CAD`, boxShadow: "-2px 2px 5px #0002" }}>
                    <Card.Body>
                      <p className="card-title">Top 10 Participants</p>
                      <div
                        id="myGrid"
                        style={{
                          marginTop: "10px",
                          height: `370px`,
                          width: "100%",
                        }}
                        className="ag-theme-alpine"
                      >
                        <AgGridReact
                          rowData={user.topParticipants} // Pass the participants data here
                          columnDefs={columns} // Define the columns
                          defaultColDef={{
                            sortable: true,
                            filter: true,
                            resizable: true,
                          }}
                          suppressHorizontalScroll={true}
                          rowClassRules={{
                            "dash-odd-row": (params) => params.node.rowIndex % 2 === 0, // Apply to odd rows
                            "dash-even-row": (params) => params.node.rowIndex % 2 !== 0, // Apply to even rows
                          }}
                        />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col xs={12} lg={6}>
                  <Card style={{ border: 0, borderLeft: `3px solid #8c564b`, boxShadow: "-2px 2px 5px #0002" }}>
                    <Card.Body>
                      <div className="d-flex align-items-center">
                        <div className="card-title text-nowrap">
                          <span>Messages By Title</span>
                        </div>
                      </div>
                      <div style={{ height: "400px" }}>
                        <ResponsiveContainer width="100%" height={400}>
                          <PieChart>
                            <Tooltip />
                            <Legend />
                            <Pie
                              data={user?.totalMessagesByJobLevel?.map((item) => ({
                                ...item,
                                jobLevel: keyMapping[item.jobLevel] || item.jobLevel, // Map jobLevel to formatted key
                              })) || []} // Fallback to an empty array
                              dataKey="totalMessages"
                              nameKey="jobLevel"
                              cx="50%"
                              cy="50%"
                              outerRadius={150}
                              fill="#8884d8"
                              label={(entry) => `${entry.jobLevel}: ${entry.totalMessages}`}
                            >
                              {user?.totalMessagesByJobLevel?.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={getColor(index)} />
                              )) || null}
                            </Pie>
                          </PieChart>
                        </ResponsiveContainer>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <Row className={"gy-3 my-1 dashboard"}>
              <Col xs={12} lg={12}>
                  <Card style={{ border: 0, borderLeft: `3px solid #8c564b`, boxShadow: "-2px 2px 5px #0002" }}>
                    <Card.Body>
                      <div className="d-flex align-items-center">
                        <div className="card-title text-nowrap">
                          <span>Active Users</span>
                        </div>
                      </div>
                      <div style={{ height: "360px" }}>
                      <ResponsiveContainer width="100%" height={400}>
                        <ComposedChart data={transformedData}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="date" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          {/* Bars for Active Users by Job Level */}
                          <Bar dataKey="store_activeUsers" stackId="a" fill="#8884d8" name="RSR & RAM" />
                          <Bar dataKey="store_covering_activeUsers" stackId="a" fill="#82ca9d" name="RSM" />
                          <Bar dataKey="district_activeUsers" stackId="a" fill="#ffc658" name="DSOM" />
                          <Bar dataKey="region_activeUsers" stackId="a" fill="#d0ed57" name="AVP" />
                          <Bar dataKey="corporate_activeUsers" stackId="a" fill="#ff8042" name="Corporate" />    
                          {/* Line for Total Active Users */}
                          <Line
                            type="monotone"
                            dataKey="totalActiveUsers"
                            stroke="#1f77b4"
                            name="Total Active Users"
                            strokeWidth={2}
                            dot={{ r: 4 }} // Optional: Add dots to the line
                          />
                        </ComposedChart>
                      </ResponsiveContainer>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Row>
      </div>
    </>
  );
};

export default MetricsUser;

function StatTile({ number, color, onClick, text, icon }) {
  return (
    <Card
      className="statCard clickable"
      style={{ borderLeft: `3px solid ${color}` }}
      onClick={onClick}
    >
      <Card.Body>
        <div className="d-flex align-items-center">
          <div>
            <p className="mb-0 text-secondary statTile-txt" style={{  }} >{text}</p>
            <h4 className="my-1" style={{ color: color }}>
              {number}
            </h4>
          </div>
          <div
            className="widgets-icons-2 rounded-circle text-white ms-auto"
            style={{
              background: `linear-gradient(45deg, ${color}, 80%, #f28f3420), 100%`,
            }}
          >
            <i className={icon}></i>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}